export default {"src":"/_next/static/media/mpm-logo.d33dc273.svg","height":674,"width":1200};